import { useState, useEffect } from 'react';
import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  Tooltip,
  Text,
} from '@chakra-ui/react';

const RangeSliderInput = ({
  title = null,
  min,
  max,
  defMin,
  defMax,
  sliderValue,
  onchange,
  onchangeend,
  slideHeight = '3px',
  boxSize = [3, 3],
  boxIcon = null,
  type = 'cash',
  step = 5,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [preVal, setPreVal] = useState('£');
  const [postVal, setPostVal] = useState('.00');

  useEffect(() => {
    if (type === 'time') {
      setPreVal('');
      setPostVal('.00 hrs');
    }
    if (type === 'cash') {
      setPreVal('£');
      setPostVal('');
    }
  }, [type]);

  return (
    <>
      {title && <Text textStyle="h6">{title}</Text>}

      <RangeSlider
        aria-label="min & max"
        id="slider"
        defaultValue={[Number(defMin), Number(defMax)]}
        min={Number(min)}
        max={Number(max)}
        value={sliderValue}
        step={step}
        colorScheme="primary"
        onChange={onchange}
        onChangeEnd={onchangeend}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <RangeSliderTrack height={slideHeight}>
          <RangeSliderFilledTrack bg="primary.500" />
        </RangeSliderTrack>
        <Tooltip
          hasArrow
          bg="teal.500"
          color="white"
          placement="bottom"
          isOpen={showTooltip}
          label={`${preVal}${sliderValue[0]}${postVal}`}
        >
          <RangeSliderThumb
            bg={boxIcon ? 'white' : 'primary.500'}
            index={0}
            boxSize={boxSize[0]}
          >
            {boxIcon}
          </RangeSliderThumb>
        </Tooltip>
        <Tooltip
          hasArrow
          bg="teal.500"
          color="white"
          placement="bottom"
          isOpen={showTooltip}
          label={`${preVal}${sliderValue[1]}${postVal}`}
        >
          <RangeSliderThumb
            bg={boxIcon ? 'white' : 'primary.500'}
            index={1}
            boxSize={boxSize[1]}
          >
            {boxIcon}
          </RangeSliderThumb>
        </Tooltip>
      </RangeSlider>
    </>
  );
};

export default RangeSliderInput;
